export default __webpack_public_path__ + "static/media/download.aa779267.svg";